import React,{useState}  from 'react'
import {Box,Typography,Container,Button, TextField, InputAdornment, InputLabel} from '@mui/material'
import {useTheme,styled } from '@mui/material/styles'
import AccountCircle from '@mui/icons-material/AccountCircle';
import MenuIcon from '@mui/icons-material/Menu';
import ArrowIcon from '@mui/icons-material/ArrowBackRounded';
import CircularProgress from '@mui/material/CircularProgress';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import {IconButton} from "@mui/material"
import {useNavigate} from 'react-router-dom'
import { add_test} from "../Redux/testSlice";
import { add_tests} from "../Redux/testsSlice";
import Header from '../Components/Header'
import useMediaQuery from '@mui/material/useMediaQuery';
import {useSelector, useDispatch} from 'react-redux';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import axios from 'axios'
import Snackbar from '@mui/material/Snackbar'
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { Alarm, ArrowDropDownCircleOutlined, CalendarTodayOutlined, MicRounded, More, PeopleOutlineOutlined, Person3Rounded, QuizOutlined, Search } from '@mui/icons-material';
import { add_assessment, add_template } from '../Redux/templatesSlice';


function generate_id (){

	const c2 = Math.floor(Math.random()*10);
	const c3 = Math.floor(Math.random()*10);
	const c4 = Math.floor(Math.random()*10);
	const c1 = Math.floor(Math.random()*10);
	const c5 = Math.floor(Math.random()*10);
	const c6 = Math.floor(Math.random()*10);
	const c7 = Math.floor(Math.random()*10);
	const c8 = Math.floor(Math.random()*10);
  
	var result = `${c1}`+`${c2}`+`${c3}`+`${c4}`+`${c5}`+`${c6}`+`${c7}`+`${c8}`;
  
  return result
  }

  const Accordion = styled((props) => (
	<MuiAccordion disableGutters elevation={4} square {...props} />
))(({ theme }) => ({
	'&:not(:last-child)': {
		borderBottom: 0,
	},
	'&:before': {
		display: 'none',
	},
	borderRadius:10,
	background:"black"
}));

const ContainerBox = styled(Box)(({ theme }) => ({
    transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
    }),
    overflowY: 'auto',
    overflowX: 'hidden',
    '&::-webkit-scrollbar': {
        width: 7,
        backgroundColor: '#060202'
    },
    '&::-webkit-scrollbar-thumb': {
        backgroundColor: '#ffffff',
        borderRadius:5
    },
    maxHeight:700,
    minHeight:300,
	minWidth:300
}));

const AccordionSummary = styled((props) => (
<MuiAccordionSummary
	expandIcon={<ArrowDropDownCircleOutlined sx={{ fontSize: 20 }} />}
	{...props}
/>
))(({ theme }) => ({
	background:theme.palette.mode === 'dark'? 'black': 'white',
	flexDirection: 'row',
	'& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
		transform: 'rotate(90deg)',
	},
	'& .MuiAccordionSummary-content': {
		marginBottom: theme.spacing(1),
	}
}));
	
const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
    }),
    overflowY: 'auto',
    overflowX: 'hidden',
    '&::-webkit-scrollbar': {
        width: 7,
        backgroundColor: '#000000'
    },
    '&::-webkit-scrollbar-thumb': {
        backgroundColor: '#ffffff',
        borderRadius: 5
    },
    maxHeight:80,
    minHeight:50
}));

const MyTests = ()=>{

	const theme = useTheme()
	const test = useSelector(state => state?.test.test);
    const [value, setValue] = React.useState(0);
	const navigate = useNavigate()
	const [loading, setLoading] = useState(false);
	const [open, setOpen] = React.useState(false);
	const [message, setMessage] = React.useState("");
	const [participants, setParticipants] = React.useState([]);
	const user = useSelector(state => state?.auth.user);
    const [search, setSearch] = React.useState("");
    const [filter, setFilter] = React.useState("");
    const [searching, setSearching] = React.useState(false);
	const [testData, setTestData] = React.useState([]);
    const [assData, setAssData] = React.useState([]);
	const [select, setSelect] = React.useState(0);
	const dispatch = useDispatch()

const handleChangeFilter = (e)=>{
    try {
        setFilter(e.target.value)
    } catch (error) {
        console.log(error)
    }
}

const handleGetTests = async ()=>{
    try {

		setLoading(true)

		const data = {
			email:user?.email
		}

        const getTests = await axios.post(`${process.env.REACT_APP_SOCKET_URL}api/user/get-tests-all/`,data,{
			headers:{
                "Content-Type":"application/json",
                "Authorization":`Bear ${user?.accessToken}`
            }
		}).catch(err=>{
			setLoading(false)
			setMessage("please,check your connection and try again")
			setOpen(true)
		})

		if (getTests?.status == 200 && getTests?.data?.success) {
			setTestData(getTests?.data.tests)
            setAssData(getTests?.data.assessments)
		}
		setLoading(false)
    } catch (error) {
        console.log(error)
    }
}

const handleSearch = async ()=>{
    try {

		setSearching(true)

		const data = {
			email:user?.email,
			search:search
		}

        const getTests = await axios.post(`${process.env.REACT_APP_SOCKET_URL}api/user/search-tests/`,data,{
			headers:{
                "Content-Type":"application/json",
                "Authorization":`Bear ${user?.accessToken}`
            }
		}).catch(err=>{
			setSearching(false)
			setMessage("please,check your connection and try again")
			setOpen(true)
		})

		if (getTests?.status == 200 && getTests?.data?.success) {
			setTestData(getTests?.data.tests)
            setAssData(getTests?.data.assessments)
		}
		setSearching(false)
    } catch (error) {
        console.log(error)
    }
}


function CustomTab(props) {
	const { children, value, index, ...other } = props;

	return (
	<div
		role="tabpanel"
		hidden={value !== index}
		id={`simple-tabpanel-${index}`}
		aria-labelledby={`simple-tab-${index}`}
		{...other}
	>
		{value === index && <ContainerBox >{children}</ContainerBox>}
	</div>
	);
}

function a11yProps(index) {
	return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
};
}

const handleSnackbarClose = ()=>{
	setOpen(false)
}
React.useLayoutEffect(()=>{
    handleSearch()
},[search])

React.useEffect(()=>{
	handleGetTests()
},[])

const handleTab = (event, newValue) => {
    setValue(newValue);
};

	return(
		<Box width="100%">
			<Header title="Create Assessment">
				<Breadcrumbs aria-label="breadcrumb">
					<Link  sx={{fontSize:12,color:"gray"}} underline="hover" href="/dashboard">
						Dashboard
					</Link>
					<Typography sx={{fontSize:12,color:"gray"}}>My Tests</Typography>
			</Breadcrumbs>			
			</Header>
			<Container>
				<Snackbar 
					anchorOrigin={{
						vertical: 'top',
						horizontal: 'left',
					}} 
					message={message} 
					onClose={handleSnackbarClose} 
					open={open} 
					autoHideDuration={2000}
				/>
				<Box mb={2} display="flex" flexDirection="row" alignItems="flex-start" justifyContent="space-between" width="100%">
					<Box width="100%">
						<Typography mt={1} mb={1} style={{fontSize:15,fontWeight:400,fontFamily:"dinofans",color:"gold"}}>
							search
						</Typography>
						<Box>
							<TextField
								placeholder='...'
								type='search'
								sx={{minHight:25,maxWidth:280}}
								InputProps={{
									endAdornment: (
									<InputAdornment  style={{width:150,justifyContent:"center",alignItems:"center",textAlign:"left"}} position="end">
										{
											searching ? <CircularProgress size={15} sx={{color:"#fff"}}/> : <Search/>
										}
									</InputAdornment>
									)
								}}
								label="search"
								value={search}
								onChange={(e)=>{setSearch(e.target.value)}}
							/>
						</Box>
					</Box>
                    <Button onClick={(e)=>{
                        e?.preventDefault()
                        navigate("/createTest")
                    }}  sx={{backgroundColor:"maroon",display:{xs:"none",md:"inline-block"},margin:2,marginLeft:1,fontFamily:"dinofans",fontSize:11,width:150,justifyContent:"center",alignItems:"center",color:"#fff"}}>
                        AI test
                    </Button>
                    <Button onClick={(e)=>{
                        e?.preventDefault()
                        navigate("/template")
                    }}  sx={{backgroundColor:"#fff",display:{xs:"none",md:"inline-block"},margin:2,marginLeft:1,fontFamily:"dinofans",fontSize:11,width:150,justifyContent:"center",alignItems:"center",color:"#000"}}>
                        Add test
                    </Button>
				</Box>
                <Box >
					<Box sx={{ borderBottom: 0,width:{xs:"100%",md:"50%"} }}>
						<Tabs value={value} onChange={handleTab} >
							<Tab sx={{fontSize:12,fontFamily:"dinofans",color:value == 0 ? "gold" : "white"}} iconPosition="start" icon={<PeopleOutlineOutlined fontSize='small' />} label="Ai" {...a11yProps(0)} />
							<Tab sx={{fontSize:12,fontFamily:"dinofans",color:value == 1 ? "gold" : "white"}} iconPosition="start" icon={<AccountCircle fontSize='small'/>} label="Template" {...a11yProps(1)} />
						</Tabs>					
					</Box>					
				</Box>
                <CustomTab value={value} index={1}>
                    {
                        assData?.length > 0 &&                
                            <Box mt={2} mb={5}>
                                <Typography  mb={1} style={{fontSize:15,fontWeight:400,fontFamily:"dinofans",color:"gold"}}>
                                    Available Assessments
                                </Typography>
                            </Box>
                    }
                    {
                        (assData?.length == 0 && loading) &&
                            <Box mt={2} mb={5}>
                                <CircularProgress size={20} sx={{color:"#fff"}}/>
                            </Box>
                    }
                    {
                        (assData?.length == 0 && !loading) &&
                            <Box mt={10} mb={5} textAlign="center" width="100%">
							    <Box textAlign="center" mb={2}>
                                    <img  width={50} height={80} src="https://res.cloudinary.com/irihocloud/image/upload/v1731198104/r14klvgmrdt5syskccyi.gif" alt="keep up" />
                                </Box>
                                <Typography  mb={1} style={{fontSize:12,fontWeight:400,fontFamily:"dinofans",color:"gold"}}>
                                    Assessments could not be found
                                </Typography>
                            </Box>
                    }
                    <Box display="flex" flexDirection="row" flexWrap="wrap" justifyContent="space-evenly" alignItems="flex-start" width="100%">
                        {
                            assData?.map((item,index)=>(
                                <Box key={index} p={1} sx={{backgroundColor:"black",m:{md:1},borderRadius:5,width:{xs:400,md:(assData?.length == 1 ? 400 : '45%')}}}>
                                    <Typography ml={1} mb={1}style={{fontSize:11,fontWeight:400,fontFamily:"dinofans",color:"gold"}}>
                                        Template assessment
                                    </Typography>
                                    <Box p={1} display="flex" flexDirection="row" flexWrap="wrap" justifyContent="space-evenly" alignItems="flex-start" width="100%">
                                        <Box>
                                            <Typography mt={1} mb={1} style={{fontSize:10,fontWeight:400,fontFamily:"dinofans",color:"gray"}}>
                                                Title 
                                            </Typography>
                                            <Typography mt={1} mb={1} style={{fontSize:12,fontWeight:400,fontFamily:"dinofans"}}>
                                                {item?.name}
                                            </Typography>
                                        </Box>
                                        <Box>
                                            <Typography mt={1} mb={1} style={{fontSize:10,fontWeight:400,fontFamily:"dinofans",color:"gray"}}>
                                                Field
                                            </Typography>
                                            <Typography mt={1} mb={1} style={{fontSize:12,fontWeight:400,fontFamily:"dinofans"}}>
                                                {item?.field}
                                            </Typography>
                                        </Box>
                                    </Box>
                                    <Box p={1} ml={2}>
                                        <Typography mb={1} style={{fontSize:10,fontWeight:400,fontFamily:"dinofans",color:"gray"}}>
                                            Description
                                        </Typography>
                                        <Typography mt={1} mb={1} style={{fontSize:12,fontWeight:400}}>
                                        {item?.description}
                                        </Typography>
                                    </Box>
                                    <Box p={1} ml={2}>
                                        <Typography mb={1} style={{fontSize:10,fontWeight:400,fontFamily:"dinofans",color:"gray"}}>
                                            Candidates
                                        </Typography>
                                        <Typography mt={1} mb={1} style={{fontSize:12,fontWeight:400}}>
                                            {item?.users?.length} candidates
                                        </Typography>
                                    </Box>
                                    <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center" width="90%">
                                        <Box>
                                            <Typography mb={1} style={{fontSize:10,fontWeight:400,fontFamily:"dinofans",color:"gray"}}>
                                                Type
                                            </Typography>
                                            <Typography mt={1} mb={1} style={{fontSize:12,fontWeight:400}}>
                                                {item?.type}
                                            </Typography>
                                        </Box>
                                        <Box>
                                            <Typography mb={1} style={{fontSize:10,fontWeight:400,fontFamily:"dinofans",color:"gray"}}>
                                                Level
                                            </Typography>
                                            <Typography mt={1} mb={1} style={{fontSize:12,fontWeight:400}}>
                                                {item?.level}
                                            </Typography>
                                        </Box>
                                        <Box>
                                            <Typography mb={1} style={{fontSize:10,fontWeight:400,fontFamily:"dinofans",color:"gray"}}>
                                                Sections
                                            </Typography>
                                            <Typography mt={1} mb={1} style={{fontSize:12,fontWeight:400}}>
                                                {item?.sections?.length > 0 ? item?.sections?.length : 0}
                                            </Typography>
                                        </Box>
                                    </Box>
                                    <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center" mt={1} width="90%">
                                        <Box>
                                            <QuizOutlined fontSize='small'/>
                                            <Typography sx={{fontSize:10,fontWeight:400}}>
                                                {item?.time}
                                            </Typography>
                                        </Box>
                                        <Box>
                                            <CalendarTodayOutlined fontSize='small'/>
                                            <Typography sx={{fontSize:10,fontWeight:400}}>
                                            {item?.start_date}
                                            </Typography>
                                        </Box>
                                        <Box>
                                            <Alarm fontSize='small'/>
                                            <Typography sx={{fontSize:10,fontWeight:400}}>
                                                {item?.start_moment}
                                            </Typography>
                                        </Box>
                                    </Box>
                                    <Box display="flex" flexDirection="row" justifyContent="center" alignItems="center" mt={1} width="90%">
                                    <Button onClick={(e)=>{
											e?.preventDefault()
											dispatch(add_assessment(item))
                                            navigate("/assessmentInfo")
										}}  sx={{backgroundColor:"gold",margin:1,borderColor:"gold",fontFamily:"dinofans",fontSize:12,width:150,justifyContent:"center",alignItems:"center"}}>
											View
										</Button>
                                    </Box>
                                </Box>
                                ))
                            }
                    </Box>
                </CustomTab>
                <CustomTab value={value} index={0}>
                    {
                        testData?.length > 0 &&                
                            <Box mt={2} mb={5}>
                                <Typography  mb={1} style={{fontSize:15,fontWeight:400,fontFamily:"dinofans",color:"gold"}}>
                                    Available Assessments
                                </Typography>
                            </Box>
                    }
                    {
                        (testData?.length == 0 && loading) &&
                            <Box mt={2} mb={5}>
                                <CircularProgress size={20} sx={{color:"#fff"}}/>
                            </Box>
                    }
                    {
                        (testData?.length == 0 && !loading) &&
                            <Box mt={10} mb={5} textAlign="center" width="100%">
							    <Box textAlign="center" mb={2}>
                                    <img  width={50} height={80} src={require("../assets/yes.gif")} alt="keep up" />
                                </Box>
                                <Typography  mb={1} style={{fontSize:12,fontWeight:400,fontFamily:"dinofans",color:"gold"}}>
                                    Assessments could not be found
                                </Typography>
                            </Box>
                    }
                    <Box display="flex" flexDirection="row" flexWrap="wrap" justifyContent="space-evenly" alignItems="flex-start" width="100%">
                        {
                            testData?.map((item,index)=>(
                                <Box key={index} p={1} sx={{backgroundColor:"black",m:{md:1},borderRadius:5,width:{xs:400,md:(testData?.length == 1 ? 400 : '45%')}}}>
                                    <Typography ml={1} mb={1}style={{fontSize:10,fontWeight:400,fontFamily:"dinofans",color:"gold"}}>
                                        AI assessment
                                    </Typography>
                                    <Box p={1} display="flex" flexDirection="row" flexWrap="wrap" justifyContent="space-evenly" alignItems="flex-start" width="100%">
                                        <Box>
                                            <Typography mt={1} mb={1} style={{fontSize:10,fontWeight:400,fontFamily:"dinofans",color:"gray"}}>
                                                Title 
                                            </Typography>
                                            <Typography mt={1} mb={1} style={{fontSize:12,fontWeight:400,fontFamily:"dinofans"}}>
                                                {item?.name}
                                            </Typography>
                                        </Box>
                                        <Box>
                                            <Typography mt={1} mb={1} style={{fontSize:10,fontWeight:400,fontFamily:"dinofans",color:"gray"}}>
                                                Field
                                            </Typography>
                                            <Typography mt={1} mb={1} style={{fontSize:12,fontWeight:400,fontFamily:"dinofans"}}>
                                                {item?.field}
                                            </Typography>
                                        </Box>
                                    </Box>
                                    <Box p={1} ml={2}>
                                        <Typography mb={1} style={{fontSize:10,fontWeight:400,fontFamily:"dinofans",color:"gray"}}>
                                            Description
                                        </Typography>
                                        <Typography mt={1} mb={1} style={{fontSize:12,fontWeight:400}}>
                                        {item?.description}
                                        </Typography>
                                    </Box>
                                    <Box display="flex" flexDirection="row" flexWrap="wrap" justifyContent="space-between" alignItems="flex-start" width="90%">
                                        <Box p={1} ml={2}>
                                            <Typography mb={1} style={{fontSize:10,fontWeight:400,fontFamily:"dinofans",color:"gray"}}>
                                                Mode
                                            </Typography>
                                            <Typography mt={1} mb={1} style={{fontSize:12,fontWeight:400}}>
                                                {
                                                    item?.isRealTime ?  "Strict" : "Open"
                                                }
                                            </Typography>
                                        </Box>
                                        <Box p={1} ml={2}>
                                            <Typography mb={1} style={{fontSize:10,fontWeight:400,fontFamily:"dinofans",color:"gray"}}>
                                                Candidates
                                            </Typography>
                                            <Typography mt={1} mb={1} style={{fontSize:12,fontWeight:400}}>
                                                {item?.users?.length} candidates
                                            </Typography>
                                        </Box>
                                    </Box>
                                    <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center" width="90%">
                                        <Box>
                                            <Typography mb={1} style={{fontSize:10,fontWeight:400,fontFamily:"dinofans",color:"gray"}}>
                                                Specialty
                                            </Typography>
                                            <Typography mt={1} mb={1} style={{fontSize:12,fontWeight:400}}>
                                                {item?.specialty}
                                            </Typography>
                                        </Box>
                                        <Box>
                                            <Typography mb={1} style={{fontSize:10,fontWeight:400,fontFamily:"dinofans",color:"gray"}}>
                                                Language
                                            </Typography>
                                            <Typography mt={1} mb={1} style={{fontSize:12,fontWeight:400}}>
                                                {item?.language}
                                            </Typography>
                                        </Box>
                                        <Box>
                                            <Typography mb={1} style={{fontSize:10,fontWeight:400,fontFamily:"dinofans",color:"gray"}}>
                                                Questions
                                            </Typography>
                                            <Typography mt={1} mb={1} style={{fontSize:12,fontWeight:400}}>
                                                {item?.questions}
                                            </Typography>
                                        </Box>
                                    </Box>
                                    <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center" mt={1} width="90%">
                                        <Box>
                                            <QuizOutlined fontSize='small'/>
                                            <Typography sx={{fontSize:10,fontWeight:400}}>
                                                {item?.level}
                                            </Typography>
                                        </Box>
                                        <Box>
                                            <CalendarTodayOutlined fontSize='small'/>
                                            <Typography sx={{fontSize:10,fontWeight:400}}>
                                            {item?.start_date}
                                            </Typography>
                                        </Box>
                                        <Box>
                                            <Alarm fontSize='small'/>
                                            <Typography sx={{fontSize:10,fontWeight:400}}>
                                                {item?.start_moment}
                                            </Typography>
                                        </Box>
                                    </Box>
                                    <Box display="flex" flexDirection="row" sx={{justifyContent:{xs:"center",md:"space-between"}}} alignItems="center" mt={1} width="90%">
                                    <Button onClick={(e)=>{
											e?.preventDefault()
											dispatch(add_test(item))
                                            navigate("/testInfo")
										}}  sx={{backgroundColor:"gold",margin:1,borderColor:"gold",fontFamily:"dinofans",fontSize:12,width:150,justifyContent:"center",alignItems:"center"}}>
											View
										</Button>
										<Button onClick={(e)=>{
											e?.preventDefault()
											dispatch(add_test(item))
											navigate("/duplicateTest")
										}}  sx={{backgroundColor:"maroon",display:{xs:"none",md:"inline-block"},margin:1,color:"#fff",fontFamily:"dinofans",fontSize:12,width:150,justifyContent:"center",alignItems:"center"}}>
											Duplicate
										</Button>
                                    </Box>
                                </Box>
                                ))
                            }
                    </Box>
                </CustomTab>
			</Container>
		</Box>
		)
}

export default MyTests